import { $http, $router } from '@/main';
import store from '@/store';
import EventBus from '@/event-bus';
import { Lang } from '@/lang/en/info';

// When the request succeeds
const success = (response) => {
  EventBus.ToastEvent.emitGlobalSuccess(Lang.toast.success.delete, true, 6000);
  store.dispatch('Locations/currentLocation', response);
  $router.push({ name: 'locations'});
};
const failure = (error) => {
  EventBus.ToastEvent.emitGlobalError(Lang.toast.error, true, 6000);
  store.dispatch('Errors/error', error.data);
};


export default (id) => {
  $http.delete(`/locations/${id}`).then((response) => {
    success(response.data);
  }).catch((error) => {
    failure(error.response);
  });
};
